// Dashboard critters: the landing page's paper characters, one per thing the
// create row makes, peeking over the top edge of their tile. Up on hover or
// keyboard focus; the first time the library opens they each pop up once in
// turn to say hello, then stay out of the way. Decorative only – the SVGs are
// aria-hidden and the CSS in dashboard-flair.css does all the moving.
(function () {
    'use strict';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const INK = '#1e1b2e';

    // Eyes and cheeks shared by every critter, so they all have one face.
    const face = (y) =>
        `<g class="cr-eyes">` +
            `<circle cx="17" cy="${y}" r="3.6" fill="#fff" stroke="${INK}" stroke-width="1.4"/>` +
            `<circle cx="27" cy="${y}" r="3.6" fill="#fff" stroke="${INK}" stroke-width="1.4"/>` +
            `<circle cx="17.6" cy="${y + 0.4}" r="1.8" fill="${INK}"/>` +
            `<circle cx="27.6" cy="${y + 0.4}" r="1.8" fill="${INK}"/>` +
        `</g>` +
        `<ellipse cx="11.5" cy="${y + 5}" rx="2.6" ry="1.7" fill="rgba(255,120,140,.45)"/>` +
        `<ellipse cx="32.5" cy="${y + 5}" rx="2.6" ry="1.7" fill="rgba(255,120,140,.45)"/>` +
        `<path d="M19.5 ${y + 6} q2.5 2.4 5 0" fill="none" stroke="${INK}" stroke-width="1.5" stroke-linecap="round"/>`;

    const body = {
        // A slide, with its title bar.
        presentation: `<rect x="4" y="8" width="36" height="30" rx="5" fill="#3660ff" stroke="${INK}" stroke-width="2"/>` +
            `<path d="M9 13.5h13" stroke="#fff" stroke-width="2.6" stroke-linecap="round" opacity=".85"/>` + face(21),
        // A worksheet, dog-eared.
        worksheet: `<path d="M8 6h21l7 7v27H8z" fill="#00c78d" stroke="${INK}" stroke-width="2" stroke-linejoin="round"/>` +
            `<path d="M29 6v7h7" fill="rgba(255,255,255,.55)" stroke="${INK}" stroke-width="2" stroke-linejoin="round"/>` + face(18),
        // A booklet, standing open.
        booklet: `<path d="M22 12c-5-3-11-3-17-1v27c6-2 12-2 17 1 5-3 11-3 17-1V11c-6-2-12-2-17 1z" fill="#e0679a" stroke="${INK}" stroke-width="2" stroke-linejoin="round"/>` +
            `<path d="M22 12v27" stroke="${INK}" stroke-width="1.6"/>` + face(21),
        // A mark: round, with a tick on its tummy.
        marking: `<circle cx="22" cy="24" r="16" fill="#8657d1" stroke="${INK}" stroke-width="2"/>` +
            `<path d="M17 32l3 3 6-6" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>` + face(20),
        // A quiz card, with a question mark for a quiff.
        quiz: `<rect x="5" y="10" width="34" height="30" rx="10" fill="#f4b447" stroke="${INK}" stroke-width="2"/>` +
            `<text x="25" y="10" font-family="Nunito, sans-serif" font-weight="900" font-size="12" fill="${INK}" transform="rotate(14 25 6)">?</text>` + face(21),
    };

    const peeks = [];
    document.querySelectorAll('#presentations-list-view .qa-tile[data-action]').forEach((tile) => {
        const svg = body[tile.dataset.action];
        if (!svg) return;
        const peek = document.createElement('span');
        peek.className = 'qa-peek';
        peek.setAttribute('aria-hidden', 'true');
        peek.innerHTML = `<svg viewBox="0 0 44 40" focusable="false">${svg}</svg>`;
        tile.appendChild(peek);
        peeks.push(peek);
    });
    if (!peeks.length || reduceMotion) return;

    // The hello: once per page load, the first time the library is on screen.
    const view = document.getElementById('presentations-list-view');
    let greeted = false;
    function hello() {
        if (greeted || !view || view.hidden) return;
        greeted = true;
        peeks.forEach((peek, i) => {
            setTimeout(() => peek.classList.add('is-hello'), 500 + i * 140);
            setTimeout(() => peek.classList.remove('is-hello'), 1500 + i * 140);
        });
    }
    hello();
    if (view && !greeted) {
        const mo = new MutationObserver(() => { hello(); if (greeted) mo.disconnect(); });
        mo.observe(view, { attributes: true, attributeFilter: ['hidden'] });
    }
})();
